import React, { useEffect, useState, } from "react";
import {
  FaAlignCenter,
  FaAlignJustify,
  FaAlignLeft,
  FaAlignRight,
  FaBold,
  FaItalic,
  FaListOl,
  FaListUl,
  FaParagraph,
  FaStrikethrough,
  FaUnderline,
} from "react-icons/fa";
import "./ToolBar.scss";
import PrintBtn from "./PrintByt";

function ToolBar({editorRef}) {


  const [activeStates, setActiveStates] = useState({
    bold: false,
    italic: false,
    underline: false,
    strikeThrough: false,
    justifyLeft: false,
    justifyCenter: false,
    justifyRight: false,
    justifyFull: false,
    insertUnorderedList: false,
    insertOrderedList: false,
  });

  // Update active styles
  const updateActiveStates = () => {
    const selection = window.getSelection();
    if (!selection || !selection.anchorNode) return;

    const parent = selection.anchorNode.parentElement;

    setActiveStates({
      bold: parent?.style.fontWeight === "bold" || parent?.tagName === "B" || parent?.tagName === "STRONG",
      italic: parent?.style.fontStyle === "italic" || parent?.tagName === "I" || parent?.tagName === "EM",
      underline: parent?.style.textDecoration === "underline" || parent?.tagName === "U",
      strikeThrough: parent?.style.textDecoration === "line-through" || parent?.tagName === "S" || parent?.tagName === "STRIKE",
      justifyLeft: parent?.style.textAlign === "left",
      justifyCenter: parent?.style.textAlign === "center",
      justifyRight: parent?.style.textAlign === "right",
      justifyFull: parent?.style.textAlign === "justify",
      insertUnorderedList: parent?.tagName === "UL",
      insertOrderedList: parent?.tagName === "OL",
    });
  };


  const toggleStyle = (range, tag, styles = {}) => {
  if (range.collapsed) return;

  const parent = range.commonAncestorContainer.parentElement;

  // Check if the parent already has the style
  const isActive =
    (tag === "strong" && (parent.tagName === "B" || parent.tagName === "STRONG")) ||
    (tag === "em" && (parent.tagName === "I" || parent.tagName === "EM")) ||
    (tag === "u" && (parent.tagName === "U")) ||
    (tag === "s" && (parent.tagName === "S" || parent.tagName === "STRIKE")) ||
    (tag === "span" && Object.keys(styles).some(key => parent.style[key] === styles[key]));

  if (isActive) {
    // Remove the style by replacing parent with its children
    const fragment = document.createDocumentFragment();
    while (parent.firstChild) {
      fragment.appendChild(parent.firstChild);
    }
    parent.replaceWith(fragment);
  } else {
    // Apply the style
    const wrapper = document.createElement(tag);
    Object.assign(wrapper.style, styles);
    wrapper.appendChild(range.extractContents());
    range.insertNode(wrapper);
  }
};

  // Apply styles using modern DOM manipulation
const exec = (command, value = null) => {
  const selection = window.getSelection();
  if (!selection || !selection.rangeCount) return;
  const range = selection.getRangeAt(0);

  switch (command) {
    case "bold":
      toggleStyle(range, "strong");
      break;
    case "italic":
      toggleStyle(range, "em");
      break;
    case "underline":
      toggleStyle(range, "u");
      break;
    case "strikeThrough":
      toggleStyle(range, "s");
      break;
    case "justifyLeft":
    case "justifyCenter":
    case "justifyRight":
    case "justifyFull":
      if (editorRef.current) {
        editorRef.current.style.textAlign = {
          justifyLeft: "left",
          justifyCenter: "center",
          justifyRight: "right",
          justifyFull: "justify",
        }[command];
      }
      break;
    case "insertUnorderedList":
      toggleList(range, "ul");
      break;
    case "insertOrderedList":
      toggleList(range, "ol");
      break;
    case "formatBlock":
      wrapBlock(range, value);
      break;
    case "fontName":
      toggleStyle(range, "span", { fontFamily: value });
      break;
    case "fontSize":
      toggleStyle(range, "span", { fontSize: value });
      break;
    case "foreColor":
      toggleStyle(range, "span", { color: value });
      break;
    default:
      break;
  }

  updateActiveStates();
};




  // Wrap selected text in a tag with optional styles
  

  // Wrap block (like H1, P, Blockquote)
  const wrapBlock = (range, tag) => {
    if (!tag) tag = "p";
    const wrapper = document.createElement(tag.toLowerCase());
    wrapper.appendChild(range.extractContents());
    range.insertNode(wrapper);
  };

  // Toggle list
  const toggleList = (range, listType) => {
    const parent = range.commonAncestorContainer.parentElement;
    if (parent.tagName.toLowerCase() === listType) {
      const fragment = document.createDocumentFragment();
      while (parent.firstChild) {
        fragment.appendChild(parent.firstChild);
      }
      parent.replaceWith(fragment);
    } else {
      const list = document.createElement(listType);
      const li = document.createElement("li");
      li.appendChild(range.extractContents());
      list.appendChild(li);
      range.insertNode(list);
    }
  };

  useEffect(() => {
    document.addEventListener("selectionchange", updateActiveStates);
    return () => document.removeEventListener("selectionchange", updateActiveStates);
  }, []);

  return (
   
      <div className="toolbarWrapper">
        <div className="toolbarWrapper_left">
            {/* Text Styles */}
        <button
          className={activeStates.bold ? "active" : ""}
          onClick={() => exec("bold")}
        >
          <FaBold />
        </button>
        <button
          className={activeStates.italic ? "active" : ""}
          onClick={() => exec("italic")}
        >
          <FaItalic />
        </button>
        <button
          className={activeStates.underline ? "active" : ""}
          onClick={() => exec("underline")}
        >
          <FaUnderline />
        </button>
        <button
          className={activeStates.strikeThrough ? "active" : ""}
          onClick={() => exec("strikeThrough")}
        >
          <FaStrikethrough />
        </button>

        {/* Alignment */}
        <button
          className={activeStates.justifyLeft ? "active" : ""}
          onClick={() => exec("justifyLeft")}
        >
          <FaAlignLeft />
        </button>
        <button
          className={activeStates.justifyCenter ? "active" : ""}
          onClick={() => exec("justifyCenter")}
        >
          <FaAlignCenter />
        </button>
        <button
          className={activeStates.justifyRight ? "active" : ""}
          onClick={() => exec("justifyRight")}
        >
          <FaAlignRight />
        </button>
        <button
          className={activeStates.justifyFull ? "active" : ""}
          onClick={() => exec("justifyFull")}
        >
          <FaAlignJustify />
        </button>

        {/* Lists */}
        <button
          className={activeStates.insertUnorderedList ? "active" : ""}
          onClick={() => exec("insertUnorderedList")}
        >
          <FaListUl />
        </button>
        <button
          className={activeStates.insertOrderedList ? "active" : ""}
          onClick={() => exec("insertOrderedList")}
        >
          <FaListOl />
        </button>

        {/* Paragraph */}
        <button onClick={() => exec("formatBlock", "p")}>
          <FaParagraph />
        </button>

        {/* Dropdowns */}
      

        <select onChange={(e) => exec("fontName", e.target.value)}>
          <option value="">Font Family</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Georgia">Georgia</option>
          <option value="Arial">Arial</option>
          <option value="Helvetica">Helvetica</option>
          <option value="Poppins">Poppins</option>
          <option value="Roboto">Roboto</option>
        </select>

        <select
          onChange={(e) => exec("fontSize", e.target.value)}
          style={{ width: "80px" }}
        >
          <option value="">Size</option>
          {[...Array(39)].map((_, i) => {
            const size = i + 12;
            return <option key={i}>{size}px</option>;
          })}
        </select>

        <input
          type="color"
          title="Text Color"
          onChange={(e) => exec("foreColor", e.target.value)}
        />
        </div>
        <div>
             <PrintBtn />
        </div>
      </div>

   
  );
}

export default ToolBar;
